import * as Yup from 'yup';

export const EmailSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("L'adresse e-mail n'est pas valide")
    .required("L'adresse e-mail est requise"),
});
